import find from 'lodash/find';
import { routeToCheckout } from './utils/routeToCheckout';
import { findRateForActiveAmenities } from 'utils/rate-utils/findRateWithAmenity';
import { getParkingType } from 'store/selectors/selectors';
export const SPOT_UPDATE_SELECTED = 'SPOT_UPDATE_SELECTED';
export const SPOT_CHANGE_MULTI_RATE = 'SPOT_CHANGE_MULTI_RATE';
export const SPOT_RESET_SELECTED_SPOT = 'SPOT_RESET_SELECTED_SPOT';
export const SPOT_RESET_SELECTED_RATE = 'SPOT_RESET_SELECTED_RATE';
export const SPOT_DETAIL_REFERRER = 'SPOT_DETAIL_REFERRER';
export { routeToCheckout };
export const updateSelected = ({ spot, referrer = null, goToSpotUrl = false, } = {}) => {
    return (dispatch, getState) => {
        let spotToDispatch = spot;
        const state = getState();
        const isTransient = getParkingType(state) === 'transient';
        const hasMultipleRates = (spot?.rates?.length ?? 0) > 1;
        if (isTransient && referrer === 'list' && spot && hasMultipleRates) {
            const { selectedSpotId, selectedSpotRateId } = state.spots;
            const spotDetailsSelectedRate = selectedSpotRateId && `${selectedSpotId}` === `${spot.spotId}`
                ? find(spot.rates, rate => `${rate.rateId}` ===
                    `${selectedSpotRateId}`)
                : undefined;
            const { activeAmenities } = state.filters;
            const matchingRate = spotDetailsSelectedRate ??
                findRateForActiveAmenities(spot.rates, spot.selectedRate, activeAmenities);
            if (matchingRate) {
                spotToDispatch = {
                    ...spot,
                    selectedRate: matchingRate,
                };
            }
        }
        dispatch({
            type: SPOT_UPDATE_SELECTED,
            payload: {
                spot: spotToDispatch,
                referrer,
                goToSpotUrl,
            },
        });
        if (goToSpotUrl && spotToDispatch) {
            dispatch(routeToCheckout({ spot: spotToDispatch }));
        }
    };
};
// Used on search controls only
export const resetSelectedSpot = () => {
    return {
        type: SPOT_RESET_SELECTED_SPOT,
    };
};
// Used on Checkout only
// newRateRule is number or string
export const changeMultiRate = ({ newRateRule, rates, }) => {
    const ruleNumber = parseInt(newRateRule, 10);
    const ruleRate = Number.isNaN(ruleNumber) ? newRateRule : ruleNumber;
    return {
        type: SPOT_CHANGE_MULTI_RATE,
        payload: {
            newRate: find(rates, rate => rate?.fullRule === ruleRate) || null,
            rid: ruleRate,
        },
    };
};
// Used on Checkout only
export const resetSelectedRate = () => {
    return {
        type: SPOT_RESET_SELECTED_RATE,
    };
};
export const setSpotDetailReferrer = (referrer) => {
    return {
        type: SPOT_DETAIL_REFERRER,
        payload: { referrer },
    };
};
